module.exports = __webpack_public_path__ + "assets/img/1c64-pf.svg";